import commonStyles from "./common";
const styles = {
  serialNumberCol: {
    ...commonStyles.tableCol,
    width: "5%"
  },
  namesCol: {
    ...commonStyles.tableCol,
    width: "55%"
  },
  valuesCol: {
    ...commonStyles.tableCol,
    width: "40%"
  },
  tableCell: {
    fontSize: 10,
    padding: 3,
    paddingTop: 5
  },
  hrLine: {
    borderTop: 1
  },
  signature: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between"
  },
  employeeSignature: {
    display: "flex",
    flexDirection: "column",
    paddingTop: 25
  },
  signatureText: {
    color: "red",
    fontWeight: "medium",
    marginRight: 10
  },
  bottomSignature: {
    flexDirection: "row",
    justifyContent: "space-between",
    paddingTop: 40,
    fontWeight: "medium"
  },
  decalarationHeading: {
    paddingTop: 30,
    paddingBottom: 10
  },
  KYCDetails: {
    paddingBottom: 50,
    paddingLeft: 100
  },
  checkBox: {
    border: 1,
    height: 5,
    width: 5,
    marginTop: 3,
    marginRight: 7
  },
  paddingLeft30: {
    paddingLeft: 30
  },
  emptyCell: {
    height: 23
  },
  employmentEmptyCell: {
    height: 38
  }
};
export default styles;
